import BaseModel from './BaseModel'
import { INSERT_PLAN_CATEGORIES } from '../redux/actions/planCategories'
import camelize from 'camelize'

class PlanSubcategory extends BaseModel {
  static reducer (action, PlanSubcategory) {
    switch (action.type) {
      case INSERT_PLAN_CATEGORIES:
        action.categories.forEach(category => {
          const subcategories = category.subcategories || []
          subcategories.forEach(subcategory => {
            PlanSubcategory.upsert(camelize(subcategory))
          })
        })
        break
    }
  }
}

PlanSubcategory.modelName = 'PlanSubcategory'

PlanSubcategory.options = {
  idAttribute: 'slug'
}

export default PlanSubcategory
